// API URLs for portfolio-related endpoints
export const PORTFOLIO_API_URLS = {
  PORTFOLIO: '/v4/public/market/portfolio',
} as const;

// BigNumber field keys used in portfolio API response processing
export const PORTFOLIO_BIG_NUMBER_KEYS = [
  // Direct instrument keys
  'spotPrice',
  'minTradeValue',
  'minOrderValue',
  'minRangeValue',
  // Nested AMM keys
  'sqrtPX96',
  'liquidity',
  'totalLiquidity',
  'involvedFund',
  'openInterests',
  'feeIndex',
  'protocolFee',
  'totalLong',
  'totalShort',
  'longSocialLossIndex',
  'shortSocialLossIndex',
  'longFundingIndex',
  'shortFundingIndex',
  'insuranceFund',
  'settlementPrice',
  'markPrice',
  'fairPrice',
  // Nested setting keys
  'minMarginAmount',
  'stabilityFeeRatioParam',
  'tip',
  // Portfolio-specific keys
  'balance',
  'size',
  'entryNotional',
  'entrySocialLossIndex',
  'entryFundingIndex',
  'entryPrice',
  // Order-specific keys
  'taken',
  'left',
  'limitPrice',
  'entryFundingIndex',
  // Range-specific keys
  'liquidity',
  'sqrtEntryPX96',
  'entryFeeIndex',
  'lowerPrice',
  'upperPrice',
] as const;

// Debounce delay for portfolio API requests (in milliseconds)
export const PORTFOLIO_DEBOUNCE_DELAY = 200;
